:host(.grid-container) {
  display: grid;

  @include breakpoint-down(md) {
    grid-template-columns: repeat($grid-sm-columns, 1fr);
    column-gap: $grid-sm-gutter;
    max-width: 100%;
    margin: $grid-sm-margin;

    &.grid-container--fixed {
      max-width: $grid-sm-max-width;
    }
  }

  @include breakpoint-up(md) {
    grid-template-columns: repeat($grid-md-columns, 1fr);
    column-gap: $grid-md-gutter;
    max-width: 100%;
    margin: $grid-md-margin;

    &.grid-container--fixed {
      max-width: $grid-md-max-width;
    }
  }

  @include breakpoint-up(lg) {
    grid-template-columns: repeat($grid-lg-columns, 1fr);
    column-gap: $grid-lg-gutter;
    max-width: 100%;
    margin: $grid-lg-margin;

    &.grid-container--fixed {
      max-width: $grid-lg-max-width;
    }
  }

  @include breakpoint-up(xlg) {
    grid-template-columns: repeat($grid-xlg-columns, 1fr);
    column-gap: $grid-xlg-gutter;
    max-width: 100%;
    margin: $grid-lg-margin;

    &.grid-container--fixed {
      max-width: $grid-xlg-max-width;
      margin: $grid-xlg-margin;
    }
  }
}
